import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import { StyledEngineProvider, ThemeProvider } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import { Snackbar } from '@atom/mui';

import RootErrorFallback from './components/common/errorPages/RootErrorFallback';
import InventoryUpload from './components/inventoryUpload/InventoryUpload';
import { muiTheme } from './utilities/muiTheme';
import { router } from './Routes';

const initializeApplication = async (store: any, client: any) => {
  const root = createRoot(document.getElementById('application'));
  root.render(
    <Provider store={store}>
      <ApolloProvider client={client}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={muiTheme}>
            <ErrorBoundary FallbackComponent={RootErrorFallback}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <InventoryUpload.Provider />
                <Snackbar.Provider />
                <RouterProvider router={router} />
              </LocalizationProvider>
            </ErrorBoundary>
          </ThemeProvider>
        </StyledEngineProvider>
      </ApolloProvider>
    </Provider>,
  );
};

const Root = {
  initializeApplication,
};

export default Root;
